import { render } from "./MarketanalyzerApp.vue?vue&type=template&id=39000896&scoped=true"
import script from "./MarketanalyzerApp.vue?vue&type=script&lang=js"
export * from "./MarketanalyzerApp.vue?vue&type=script&lang=js"

import "./MarketanalyzerApp.vue?vue&type=style&index=0&id=39000896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39000896"]])

export default __exports__